





















































import Vue from "vue";
import DocumentToolbarMenuButton from "@/components/modules/document/toolbar/DocumentToolbarMenuButton.vue";
import MarkAsFavoriteAction from "@/components/modules/document/toolbar/actions/MarkAsFavoriteAction.vue";
import AddCommentAction from "@/components/modules/document/toolbar/actions/AddCommentAction.vue";
import PrintDocumentAction from "@/components/modules/document/toolbar/actions/PrintDocumentAction.vue";
import EmailDocumentAction from "@/components/modules/document/toolbar/actions/EmailDocumentAction.vue";
import CompareDocumentVersionAction from "@/components/modules/document/toolbar/actions/CompareDocumentVersionAction.vue";
import GoToDocumentManagementAction from "@/components/modules/document/toolbar/actions/GoToDocumentManagementAction.vue";
import ShowDocumentQrCodeAction from "@/components/modules/document/toolbar/actions/ShowDocumentQrCodeAction.vue";
import LinkDocumentAction from "@/components/modules/document/toolbar/actions/LinkDocumentAction.vue";
import ShowDocumentDetailsAction from "@/components/modules/document/toolbar/actions/ShowDocumentDetailsAction.vue";
import ShowChangesComparedToPreviousAction from "@/components/modules/document/toolbar/actions/ShowChangesComparedToPreviousAction.vue";
import ShowDocumentCommentsDrawerAction from "@/components/modules/document/toolbar/actions/ShowDocumentCommentsDrawerAction.vue";
import ShowDocumentReviewInstructionsAction from "@/components/modules/document/toolbar/actions/ShowDocumentReviewInstructionsAction.vue";
import ShowReviewHistoryAction from "@/components/modules/document/toolbar/actions/ShowReviewHistoryAction.vue";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import { DocumentAnchor, DocumentField } from "@infoland/iprova-api";
import { CommentType, DocumentRoute } from "@/enums";
import { DocumentReviewer } from "@/types/document/documentReviewer";
import storeHelper from "@/store/store-helper";
export default Vue.extend({
    name: "MoreMenuDocumentActions",
    components: {
        DocumentToolbarMenuButton,
        MarkAsFavoriteAction,
        AddCommentAction,
        PrintDocumentAction,
        EmailDocumentAction,
        CompareDocumentVersionAction,
        GoToDocumentManagementAction,
        ShowDocumentQrCodeAction,
        ShowDocumentDetailsAction,
        ShowChangesComparedToPreviousAction,
        ShowDocumentCommentsDrawerAction,
        ShowDocumentReviewInstructionsAction,
        ShowReviewHistoryAction,
        LinkDocumentAction
    },
    props: {
        documentProperties: Object as () => DocumentVersionInfo,
        documentFields: Array as () => DocumentField[],
        isDocumentReady: Boolean,
        documentRoute: String as () => DocumentRoute,
        shouldShowCommentsDrawer: Boolean,
        changesSincePreviousVersion: String,
        commentSubjectSelections: Array as () => DocumentAnchor[],
        commenterTypeForAddingComment: String as () => CommentType,
        userIsDocumentAdministrator: Boolean,
        showChangesComparedToPrevious: Boolean,
        hasReviewInstructions: Boolean,
        reviewer: Object as () => DocumentReviewer,
        showAddComment: Boolean
    },
    data: function () {
        return {
            showMoreDialog: false
        };
    },
    watch: {
        showMoreDialog: function () {
            storeHelper.siteStore.setIsDialogDisplayed(this.showMoreDialog);
        }
    },
    computed: {
        enable(): boolean {
            return (
                (this.documentProperties?.can_be_compared ||
                    this.documentProperties?.can_be_edited ||
                    this.changesSincePreviousVersion ||
                    this.isReviewDocument ||
                    (this.isReviewDocument && this.hasReviewInstructions) ||
                    !this.mdAndUp) &&
                this.isDocumentReady
            );
        },
        lgAndUp(): boolean {
            return this.$vuetify.breakpoint.lgAndUp;
        },
        mdAndUp(): boolean {
            return this.$vuetify.breakpoint.mdAndUp;
        },
        smAndUp(): boolean {
            return this.$vuetify.breakpoint.smAndUp;
        },
        isReviewDocument(): boolean {
            return this.documentRoute === DocumentRoute.ReviewDocument;
        },
        showCommentsButton(): boolean {
            return (this.documentRoute === DocumentRoute.ReviewDocument || this.documentRoute === DocumentRoute.CheckDocument) && !this.mdAndUp;
        },
        shouldDisplayLarge(): Boolean {
            return (
                (this.documentProperties && this.documentProperties.can_be_compared && this.documentProperties.can_be_edited) ||
                this.documentRoute == DocumentRoute.ReviewDocument
            );
        }
    },
    methods: {
        setShowMoreDialog(): void {
            this.showMoreDialog = true;
        },
        showCommentsDrawer(): void {
            this.showMoreDialog = false;
            this.$emit("show-comments-drawer");
        }
    }
});
